import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserDto, User } from '../../../../models/user.model';
import { AccountInfo } from '../../models/account-info';
import { AccountInfoService } from '../../services/account-info.service';


@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {

  accounts:AccountInfo[];
  constructor(
    public dialogRef: MatDialogRef<UserEditComponent>,
    private accountService:AccountInfoService,
    @Inject(MAT_DIALOG_DATA) public data: User) {}

    ngOnInit() {
      this.accountService.GetCached().subscribe((result)=>{
        this.accounts = result;
      });    
      this.dialogRef.keydownEvents().subscribe(event => {
        if (event.key === "Escape") {
            this.onCancel();
        }
    });

    this.dialogRef.backdropClick().subscribe(event => {
        this.onCancel();
    });    
  }
  onCancel(){
    this.dialogRef.close();
  }
}
